import { useTranslation } from "next-i18next"

const useOmniChannel = (authorData = {}) => {
  const { t } = useTranslation()
  const i18n = {
    firstNameLabel: "First Name",
    lastNameLabel: "Last Name",
    mobileNumberLabel: "Mobile Number",
    getOtpLabel: "Get OTP",
    emailLabel: "Email",
    pinCodeLabel: "Pin Code",
    noOfBathroomLabel: "Number of Bathrooms",
    budgetLabel: "Budget",
    submitLabel: "Submit Request",
    kecCityLabel: "Kohler Experience Center/Studio City",
    cityLabel: "City",
    stateLabel: "State",
    productCategoryLable: "Product Category",
    fileTypeLabel: "Choose document type",
    constructionTypeLabel: "Construction Type",
    siteAddressLabel: "Site Address",
    purchasePickListLabel: "When do you expect to make your purchase?",
    mandatoryLabel: "Fields marked with * are required.",
    disclaimerTxt:
      "This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.",
    disclaimerLink1: "Privacy  Policy",
    disclaimerLink2: "Subject Access Request",
    inspirationTitle:
      "PLEASE ENTER YOUR DETAILS TO DOWNLOAD INSPIRATION GALLERY",
    selfRegistrationTitle:
      "PLEASE ENTER YOUR DETAILS TO DOWNLOAD INSPIRATION GALLERY",
    kecAppointmentTitle:
      "Fill in the form below, and our team will get in touch to schedule your appointment at a convenient time.",
    siteVisitTitle:
      "Fill in the form below, and our team will get in touch to schedule your appointment at a convenient time.",
    whatAppConent:
      "I consent to receive marketing communication and offers from Kohler on WhatsApp.",
    smsEmailConsent:
      "I consent to receive marketing communication and offers from Kohler on SMS and Email.",
    defaultAddress: "Default Address",
    firstNameError: "Your first name is required",
    lastNameError: "Your last name is required",
    noEmailError: "Please provide your email address",
    emailAddressError: "Please enter a valid email address",
    wrongPincodeError: "Invalid pincode",
    noPinCodeError: "Pin Code is required",
    inValidPinCodeError: "Please enter a 6 digit valid pincode",
    bathroomNoEmpty: "Please enter valid number of bathrooms",
    mobileNumberError: "Please enter mobile number",
    validMobileNoError: "Please enter a valid mobile number",
    mobileVerifyNumber: "Please verify your Mobile Number",
    mobileNumberVerified: "Your number has been verified",
    productCategoryError: "Please Select Product Category",
    kecCityError: "Please select Kec City",
    purchasePickError: "Please select purchase timeline",
    verificationTitle: "Mobile number verification",
    verify: "Verify",
    confirmationmodal:
      'Thank you for completing mobile number verification. Click "Close" to return to the form.',
    receiveOTP: "Your OTP has expired",
    resend: "Resend OTP",
    invalidOTP: "OTP is invalid or no longer active",
    firstNameDescription:
      "Please enter the first name as mentioned on the invoice",
    lastNameDescription:
      "Please enter the last name as mentioned on the invoice",
    invoice: "An invoice or receipt from the place of purchase",
    stamped: "Stamped directly onto the product itself",
    uploadFileSizeError:
      "You have exceeded the maximum file size limit of 5MB. Please upload less than 5MB",
    provideImageError:
      "Please provide the invoice in PNG, JPG, JPEG or PDF format",
    uploadFileTypeError: "You shall upload only PNG, JPG, JPEG, PDF format.",
    ariaLabel: {
      imageRemove: "Document removed successfully",
    },
    drag: "Drag",
    drop: "Drop",
    or: "Or",
    uploadPhoto: "Upload File",
    addPhoto: "Add More Photo(s)",
    stateError: "Please provide your state",
    cityError: "Please provide your city",
    siteAddressError: "Please provide site address",
    constructionTypeError: "Please Select Construction Type",
    fileTypeError: "Please Select Document Type",
    alternateMobileNumberLabel: "Alternate Mobile Number",
    addressLabel: "Address",
    landmarkLabel: "Landmark",
    productDetailsLabel: "Product Details",
    reportIssueLabel: "Report Issue",
    dateOfInvoiceLabel: "Date of Invoice DD/MM/YYYY",
    addressError: "Please provide Address",
    productDetailsError: "Please Select Product Details",
    reportIssueError: "Please provide report issue",
    slotError: "Please Choose Date and Time"
  }
  return i18n
}

export default useOmniChannel
